import React, { useEffect, useState } from 'react';
import OrgSignupDetails from './OrgSignupDetails';
import { getLeadsDetailsApi } from '../../redux/Reducers/commonApis';
import { useDispatch } from 'react-redux';
import { setGroupDataAction } from '../../redux/Actions/GroupActions';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

function OrgSignup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentURL = new URL(window.location.href);
  const urlParams = new URLSearchParams(currentURL.search);
  const [loading, setLoading] = useState(false);
  const token = urlParams.get('token');
  const [leadData, setLeadData] = useState(null);
  const [alreadySignedUp, setAlreadySignedUp] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (alreadySignedUp && countdown > 0) {
      const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (alreadySignedUp && countdown === 0) {
      navigate('/signin');
    }
  }, [alreadySignedUp, countdown]);

  const getLeadsDetailsApiFn = (data) => {
    setLoading(true);
    const response = getLeadsDetailsApi(data);
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        setLeadData(res?.data);
        setLoading(false);
      } else {
        if (res?.status === 400 && res?.message === 'You are already signed up, redirecting to login page') {
          setAlreadySignedUp(true);
          setLoading(false);
        } else if (res?.status === 400 && res?.message === 'Token is not active.') {
          toast.error('Token is not active. Please sign in.');
          navigate('/signin');
        } else if (res?.error?.message) {
          toast.error(res.error.message);
        } else {
          toast.error('Something went wrong');
        }
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    token && getLeadsDetailsApiFn({ token: token });
  }, [token]);

  if (alreadySignedUp) {
    return (
      <div className='flex h-[100dvh] overflow-hidden'>
        <div className='relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden'>
          <main className='flex grow items-center justify-center bg-[#01235A]'>
            <div className='mx-auto max-w-md justify-center'>
              <div className='p-6'>
                <div className='rounded-lg bg-white p-8 text-center'>
                  <div className='mb-4'>
                    <svg
                      className='mx-auto h-12 w-12 text-amber-500'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth={2}
                        d='M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z'
                      />
                    </svg>
                  </div>
                  <h2 className='mb-2 text-xl font-semibold text-slate-800'>Already Signed Up</h2>
                  <p className='mb-6 text-sm text-slate-600'>
                    You are already signed up, redirecting to login page in{' '}
                    <span className='font-semibold'>{countdown}</span> seconds.
                  </p>
                  <button
                    className='go-textwhite-15 rounded-full bg-[#548ff7] px-4 py-2 text-center'
                    onClick={() => navigate('/signin')}
                  >
                    Go to Login
                  </button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return <OrgSignupDetails token={token} loading={loading} data={leadData} />;
}

export default OrgSignup;
